/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Settings_SavedInputs */

const en_simple_settings_saved = /** @type {(inputs: Simple_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode saved`)
};

const id_simple_settings_saved = /** @type {(inputs: Simple_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode disimpan`)
};

/**
* | output |
* | --- |
* | "Mode saved" |
*
* @param {Simple_Settings_SavedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_settings_saved = /** @type {((inputs?: Simple_Settings_SavedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Settings_SavedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_settings_saved(inputs)
	return en_simple_settings_saved(inputs)
});